module.exports = __webpack_public_path__ + "static/media/slide-general-white.0cb1b7c9.svg";